export const bestChoiceIconStyle = (isActive: boolean) => {
  if (isActive) {
    return "#fff"
  }
  return "#640EF1"
}
